import { SceneBase } from '@jollywise/jollygoodgame';
import { KEYS } from 'game/constants/SceneConstants';
import { FONT_BASE } from '../constants/AppFonts';
export default class HowToPlay extends SceneBase {
  constructor() {
    super({ key: KEYS.HowToPlay, active: false });
  }
  preload() {}
  init(config) {
    this._config = config.data;
  }
  create() {
    super.create();

    this.add.rectangle(0, 0, 1680, 720, 0x000000, 0.8).setOrigin(0);

    this.currentPage = this._config.index || 0;

    this.pageMarkers = [];
    this.pages = [];
    for (let i = 0; i < this._config.content.length; i++) {
      const config = this._config.content[i];

      const page = this.add.container();

      const pagnation = this.add.image(0, 0, 'shared_ui', 'pagination_01');
      pagnation.setOrigin(0.5, 0);
      this.pageMarkers.push(pagnation);

      const panelBg = this.add.image(840, 360, 'howtoplay', 'howtoplay_background');
      const panel = this.add.image(840, 357, 'howtoplay', config.image_key);

      const titleText = this.game.copy.get(config.copy_title);
      const copyText = this.game.copy.get(config.copy_instruction);

      const title = this.add
        .text(840, 140, titleText, {
          font: `50px ${FONT_BASE.TITLE}`,
          color: '#ffffff',
          align: 'center',
          wordWrap: { width: 700 },
        })
        .setOrigin(0.5);

      const copy = this.add
        .text(840, 585, copyText, {
          font: `25px ${FONT_BASE.COPY}`,
          color: '#000000',
          align: 'center',
          wordWrap: { width: 600 },
        })
        .setOrigin(0.5);

      page.x = i === 0 ? 840 : 2520;

      // add the panel to the page and update the array

      page.add([panelBg, panel, copy, title]);

      this.pages.push(page);
    }

    // calculate the total width of page markers to determine an offset
    const offset = 840 - ((this.pageMarkers.length - 1) * (this.pageMarkers[0].width + 14)) / 2;
    // position page markers to center them
    this.pageMarkers.forEach((p, i) => (p.x = offset + i * (p.width + 14) + p.width * 0.5));
    this.pageMarkers.forEach((p, i) => {
      p.x = offset + i * (p.width + 14) + p.width * 0.5;
      p.y = 652;
    });

    // this.pageMarkers[this.currentPage].setFrame('pagination_02');

    this.game.hud.setState('HOW_TO_PLAY');

    // listen for hub button events
    this.game.hud.events.on('btn_htp_next', this.nextPage, this);
    this.game.hud.events.on('btn_htp_prev', this.prevPage, this);

    // show the first page
    this.currentPageIndex = 0;
    this.showPage(this.currentPageIndex);
  }

  nextPage() {
    if (this.tweening) return;
    // show the next page, slide in from the right
    this.showPage(this.currentPageIndex + 1, -1);
  }

  prevPage() {
    if (this.tweening) return;
    // show the prev page, slide in from the left
    this.showPage(this.currentPageIndex - 1, 1);
  }

  // show a specific page
  showPage(index, direction) {
    // if page does not exits, bail
    if (!this.pages[index]) return;

    // if there is an active page, get rid of it
    if (this.currentPageDisplay && direction) {
      this.tweens.add({
        targets: this.currentPageDisplay,
        x: 1680 * direction,
        ease: Phaser.Math.Easing.Quadratic.In,
        duration: 300,
      });
    } else if (this.currentPageDisplay && !direction) {
      this.currentPageDisplay.x = 1680;
    }

    // set the current page
    this.currentPageIndex = index;
    this.currentPageDisplay = this.pages[index];

    // if a direction is passed, tween based on the direction
    if (direction) {
      this.currentPageDisplay.x = 1680 * direction * -1;
      this.tweens.add({
        targets: this.currentPageDisplay,
        x: 0,
        ease: Phaser.Math.Easing.Quadratic.Out,
        duration: 500,
        onComplete: this.handleTweenEnd,
        onCompleteScope: this,
      });
      this.tweening = true;
    } else this.currentPageDisplay.x = 0;

    // update pagination markers and cycle buttons
    this.pageMarkers.forEach((p, i) =>
      p.setFrame(i === this.currentPageIndex ? 'pagination_02' : 'pagination_01')
    );

    this.updateCycleButtons();
  }

  handleTweenEnd() {
    this.tweening = false;
    const pageIn = this.pages[this.currentPage];
  }

  enable() {
    if (this.buttonEnabled) return;

    super.enable();
    this.alpha = 1;
    this.clearTint();
  }

  disable() {
    if (!this.buttonEnabled) return;

    super.disable();
    this.alpha = 1;
    this.tint = 0x888888;
  }

  updateCycleButtons() {
    const prevBtn = this.game.hud.getButton('btn_htp_prev');
    const nextBtn = this.game.hud.getButton('btn_htp_next');
    console.log(prevBtn, nextBtn);

    if (!prevBtn || !nextBtn) {
      return;
    } else {
      this.currentPageIndex > 0 ? prevBtn.enable() : prevBtn.disable();
      this.currentPageIndex < this.pages.length - 1 ? nextBtn.enable() : nextBtn.disable();
    }

    // this.game.hud.getButton('btn_htp_prev').visible = this.currentPageIndex > 0;
    // this.game.hud.getButton('btn_htp_next').visible = this.currentPageIndex < this.pages.length - 1;
  }

  shutdown() {
    this.game.hud.events.off('btn_htp_next', this.nextPage, this);
    this.game.hud.events.off('btn_htp_prev', this.prevPage, this);
    super.shutdown();
  }
}
